import React from 'react';
import { type IHostProps } from '@wix/yoshi-flow-editor';
import { connect } from '../../../common/components/runtime-context';
import { getLayoutPostSize } from '../../../common/selectors/app-settings-selectors';
import { type Actions, type AppState } from '../../../common/types';
import PageTabs from './page-tabs';
import PageTitle from './page-title';
import styles from './my-posts-frame-desktop.scss';

type Props = {
  children?: React.ReactNode;
} & ReturnType<typeof mapRuntimeToProps>;

const MyPostsFrameDesktop = ({ children, layoutPostSize }: Props) => (
  <section
    className={styles.root}
    style={{ '--width': layoutPostSize ? `${layoutPostSize}px` : undefined }}
  >
    <div className={styles.contentWrapper}>
      <header className={styles.header}>
        <PageTitle />
      </header>
      <section className={styles.tabs}>
        <PageTabs />
      </section>
      {children}
    </div>
  </section>
);

const mapRuntimeToProps = (
  state: AppState,
  _ownProps: {},
  _actions: Actions,
  host: IHostProps,
) => ({
  layoutPostSize: getLayoutPostSize({
    state,
    hostWidth: host.dimensions.width || undefined,
  }),
});

export default connect(mapRuntimeToProps)(MyPostsFrameDesktop);
